module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "single-content container"
  }, [(_vm.info) ? _c('div', {
    staticClass: "infobox",
    style: ({
      boxShadow: 'inset 30px 0 0 ' + _vm.color
    })
  }, [(_vm.header) ? _c('h2', [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _c('div', {
    staticClass: "single-description"
  }, [(_vm.header) ? _c('h2', [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccab2c6"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/partials/single-section.vue
// module id = 106
// module chunks = 0